import {default as HamrahButton} from './HamrahButton-Component'
export default HamrahButton